import { StepStatus } from "../interfaces/StepStatus";
//
// export interface ClinicalTrialStep {
//     id: number;
//     clinical_trial_id: number;
//     clinical_trial: boolean;
//     trial_study_detail: boolean;
//     trial_eligibility_timeline: boolean;
//     trial_recruitment_detail: boolean;
//     trial_outcome: boolean;
//     is_submitted: boolean;
//     step_completion_status: boolean;
//     current_step: string;
//     next_step: string;
//     submitted_date: string;
//     created_by: number;
//     created_at: string;
//     updated_by: number;
//     updated_at: string;
//     deleted_by?: number;
//     deleted_at?: string;
// }
export async function getFormStepStatus(
    client: any,
    filterID: number,
    formStepsStatusEndpoint: string
): Promise<StepStatus | null> {
    try {
        const response = await client.post(formStepsStatusEndpoint, {
            id: filterID
        });
        return response.data as StepStatus;
    } catch (error) {
        console.error("Error fetching form step status:", error);
        return null;
    }
}
